module.exports = __webpack_public_path__ + "static/media/beautesoftlogo.f954b537.png";